import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'vimeo',
  standalone: true
})
export class VimeoPipe implements PipeTransform {

  constructor(private dom: DomSanitizer) {

  }
  transform(_url: any, args?: any): any {
    if (!_url) { return ''; }
    _url = _url.replace('https://vimeo.com/', 'https://player.vimeo.com/video/');
    return this.dom.bypassSecurityTrustResourceUrl(_url);
  }

}
